import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  makeStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import {
  ExpandMore,
  ChevronRight,
  AttachFile,
  InsertDriveFile, // 📄 generic file
  Description, // 📝 text/document
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  treeItem: {
    "& .MuiTreeItem-content": {
      padding: "6px 8px",
      borderRadius: "6px",
      fontSize: "14px",
      fontWeight: 500,
      color: "#333",
      "&:hover": {
        backgroundColor: "rgba(25, 118, 210, 0.08) !important",
      },
      "&.Mui-focused": {
        backgroundColor: "rgba(25, 118, 210, 0.15) !important",
      },
      "&.Mui-selected": {
        backgroundColor: "rgba(25, 118, 210, 0.25) !important",
        color: "#1976d2",
        fontWeight: 600,
      },
    },
    "& .MuiTreeItem-label": {
      fontSize: "14px",
      padding: "2px 6px",
    },
  },
  dialogHeader: {
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 16px",
    width: "100%",
    gap: 8,
  },
  title: {
    color: "white",
    margin: 0,
    flex: 1,
  },
  closeBtn: {
    color: "white",
    flex: "0 0 auto",
  },
}));

const CommonDialog = ({
  open,
  onClose,
  title,
  orgData = [],
  onSelect,
  maxWidth = "sm",
}) => {
  const classes = useStyles();

  const renderTree = (nodes) => (
    <TreeItem
      key={nodes.id}
      nodeId={String(nodes.id)}
      label={nodes.name}
      classes={{ root: classes.treeItem }}
      onClick={() => {
        if (!nodes.children || nodes.children.length === 0) {
          onSelect?.(nodes);
          onClose();
        }
      }}
    >
      {Array.isArray(nodes.children)
        ? nodes.children.map((node) => renderTree(node))
        : null}
    </TreeItem>
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      <DialogTitle disableTypography style={{ padding: 0 }}>
        <Box className={classes.dialogHeader}>
          
          <Typography variant="h6" noWrap className={classes.title}>
            {title}
          </Typography>

          <IconButton
            size="small"
            onClick={onClose}
            className={classes.closeBtn}
            aria-label="Close"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <TreeView
          defaultCollapseIcon={<Description />}
          defaultExpandIcon={<Description />}
        >
          {orgData.map((node) => renderTree(node))}
        </TreeView>
      </DialogContent>
    </Dialog>
  );
};

export default CommonDialog;
